import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FeescategoryserviceService } from './feescategoryservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { FeesCategory, feesCategoryPrices } from './feesCategory.model';
import { OptionService } from 'src/app/options/option.service';

@Component({
  selector: 'app-feescategory',
  templateUrl: './feescategory.component.html',
  styleUrls: ['./feescategory.component.css'],
  queries: {
    contentRef: new ViewChild("ModalCategory")
  },
})
export class FeescategoryComponent implements OnInit {

  catecoryFeesForm!: FormGroup;
  public contentRef!: TemplateRef<any>;
  updateMode: boolean = false;
  categoryName!: string;
  categories: any;
  spinnerOverlay = false;
  feesCategory: FeesCategory = {} as FeesCategory;
  _feesCategoryPrices: feesCategoryPrices = {} as feesCategoryPrices
  selectedCategory = 0;
  constructor(private dialog: MatDialog,
    private service: FeescategoryserviceService,
    private snackBar: MatSnackBar,
    private optionService: OptionService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.connectFormGroup();
    this.getCategories();
  }

  connectFormGroup() {

    let _feesAmount = new FormArray([]);

    this.catecoryFeesForm = new FormGroup({

      catgId: new FormControl(null),
      feesAmounts: _feesAmount
    });

    this.addFeesAmountRows();
  }

  getFeesAmountControls() {
    return (<FormArray>this.catecoryFeesForm.get('feesAmounts')).controls;
  }

  addFeesAmountRows() {

    for (let i = 0; i < 5; i++) {
      (<FormArray>this.catecoryFeesForm.get('feesAmounts')).push(
        new FormGroup({
          id: new FormControl(0),
          fromAmount: new FormControl(this._feesCategoryPrices.fromAmount, [Validators.required]),
          toAmount: new FormControl(this._feesCategoryPrices.toAmount, [Validators.required]),
          totalFees: new FormControl(this._feesCategoryPrices.totalFees, [Validators.required]),
          appFees: new FormControl(this._feesCategoryPrices.appFees, [Validators.required]),
          merchantFees: new FormControl(this._feesCategoryPrices.merchantFees, [Validators.required]),
        }))
    }
  }

  getCategories() {
    this.service.getAllCategory().subscribe(data => {
      this.categories = data;
    })
  }

  getByCategoryId() {
    const control = (<FormArray>this.catecoryFeesForm.get('feesAmounts'));
    control.reset();
    this.service.getByCategory(this.catecoryFeesForm.get("catgId")?.value).subscribe(data => {
      control.patchValue(data);
    })
  }

  addNewCategory() {
    this.openCategoryDialog()
  }

  saveCategory() {
    this.spinnerOverlay = true;
    var obj = {
      name: this.categoryName
    }
    this.service.CreateCategory(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.dialog.closeAll();
      this.getCategories();
      this.spinnerOverlay = false;

    })
  }

  catgSelectChange() {
    this.selectedCategory = this.catecoryFeesForm.get("catgId")?.value;
    this.getByCategoryId()
  }

  onNoClick() {
    this.dialog.closeAll();
  }

  openCategoryDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  saveForm() {

    const controls = (<FormArray>this.catecoryFeesForm.get('feesAmounts'));

    for (let i = 0; i < controls.value.length; i++) {
      var appFees = controls.value[i].appFees;
      var merchantFees = controls.value[i].merchantFees;
      var totalFees = controls.value[i].totalFees;

      if ((appFees + merchantFees) != totalFees) {
        this.openSnackBar("المجموع غير متساوي", 'snackBarError');
        return;
      }
    }
    this.spinnerOverlay = true;


    var obj = {
      catgId: this.catecoryFeesForm.get("catgId")?.value,
      feesAmounts: this.catecoryFeesForm.get("feesAmounts")?.value
    }


    this.service.saveCategoryPrices(obj).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    })
  }

  setAsDefault() {
    this.updateSystemSettings();
  }


  updateSystemSettings() {
    this.spinnerOverlay = true;
    var obj = {
      "key": "Default_eFFees_Category",
      "value": this.catecoryFeesForm.get('catgId')?.value
    }

    this.optionService.updateSystemSettings(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
      })
  }

}
